// Imports
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '../../../../shareables/foundation/admin-ui/components/content/box';
import Heading from '../../../../shareables/foundation/admin-ui/components/content/heading';
import APIForm, { APIFormOptions } from '../../../../shareables/integrations/api/components/form';
import Card from '../../../../shareables/front-end/stripe-component-wrappers/card';
import ResellerContext from '../../../resources/reseller-provider/context';
import { PutPaymentMethodParameters } from '../../../../shareables/types/api/main/reseller/billing/payment-method/put';


// Define the accepted props
interface Props {
	replace?: boolean;
}


// Function component
const UpsertPaymentMethod: React.FC<Props> = ({ replace }) => {
	// Use React Router functionality
	const navigate = useNavigate();
	
	
	// Use context
	const reseller = useContext(ResellerContext);
	
	
	// Build form options
	const formOptions: APIFormOptions<PutPaymentMethodParameters, undefined, undefined> = {
		action: 'PUT',
		uri: `/reseller/${reseller?.id ?? ''}/billing/payment-method`,
		submitButton: {
			text: replace ? 'Save' : 'Add',
		},
	};
	
	
	// Return JSX
	return (
		<React.Fragment>
			<Heading size={1}>{replace ? 'Replace' : 'Add'} payment method</Heading>
			
			<APIForm options={formOptions} onCancel={() => navigate(-1)} onCompletion={() => navigate('..')}>
				<Box>
					<Card name='token' label='Card details' />
				</Box>
			</APIForm>
		</React.Fragment>
	);
};

export default UpsertPaymentMethod;
